App.prototype.alert = function(message, level) {
    
    var modal = this.appendModal('modal-alert')
    
    modal.find('.modal-dialog').addClass('modal-lg')
    
    var alert = this.createAlertElement(message, level)
    
    if (alert) {
	    modal.find('.modal-content').html(alert);
	    modal.modal('show');
        this.dispatchEvent('alert', {message: message, level: level})
    }
    
    return this
}

App.prototype.createAlertElement = function(message, level) {
    
    var levels = ['success', 'warning', 'danger', 'info']
    
    if (!levels.includes(level)) {
	    return ''
    }
    
    return $('<div class="alert alert-'+ level +'"></div>').text(message)
}

App.addModule(function(app) {

    app.on('loaded', () => {

        $('.error-msg span, .alert-danger').each(function() {
            var alert = $(this)
            var level = '' // TODO
            app.dispatchEvent('alert', {message: alert.html(), level: level})
        })
    })
})
